import { client } from '../client';
import { RxPayload } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const getCasePatientRx = async (caseId: number, userRole?: string): Promise<RxPayload> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/cases/${caseId}/patient_rx`);

  return data;
};
